import { defineComponent } from 'vue';

export default defineComponent({
  name: 'footer',
  data() {
    return {
      year:new Date().getFullYear()
    }
  },
});